<mat-dialog-content class="dialog-content">
  <div class="header">
    <h2>{{ data.title | i18nextCap }}</h2>

    <div class="buttons-options">
      <button mat-icon-button (click)="onDownload()">
        <div class="icon blue-icon">
          <fa-icon [icon]="faDownload" size="2x"></fa-icon>
        </div>
      </button>

      <button mat-icon-button (click)="onLeave()">
        <div class="icon blue-icon">
          <fa-icon [icon]="faCircleXmark" size="2x"></fa-icon>
        </div>
      </button>
    </div>
  </div>
  @if (data.imageUrl) {
    <div class="imageContainer">
      @switch (getFileTypeName(data.file)) {
        @case ('image') {
          <img [src]="data.imageUrl" />
        }
        @case ('video') {
          <video autoplay controls [src]="data.imageUrl"></video>
        }
        @default {
          <div class="filePreview">
            <fa-icon
              [icon]="fileIcon"
              size="6x"
              class="filePreviewColor"
            ></fa-icon>
            <span>{{ formatFileName(data.file.file.fileName) }}</span>
            <button mat-flat-button (click)="onDownload()">
              <div class="icon blue-icon">
                <fa-icon [icon]="faDownload" size="2x"></fa-icon>
              </div>
              <span>
                {{ 'download' | i18nextCap }}
              </span>
            </button>
          </div>
        }
      }
    </div>
  }
</mat-dialog-content>
